<template>
  <!-- 退出确认弹窗 -->
  <transition name="fade" mode="out-in">
    <div class="v3-popup exit-confirm-popup" v-show="visible">
      <div class="v3-popup-mask" @click="closePopup"></div>
      <div class="v3-popup-content small">
        <div class="v3-popup-content-close" @click="closePopup"></div>
        <div class="v3-popup-content-title">{{ langData.exitConfirmTitle }}</div>
        <div class="v3-popup-content-content">
          <p>{{ langData.exitConfirmLine1 }}</p>
          <p>{{ langData.exitConfirmLine2 }}</p>
        </div>
        <div class="v3-popup-content-footer">
          <div class="confirm-btn btns" @click="confirmExit">{{ langData.confirmBtn }}</div>
          <div class="cancel-btn btns" @click="closePopup">{{ langData.cancelBtn }}</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import LanguageHook from "@hooks/language";

const { langData } = LanguageHook();

// 定义 props
const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
});

// 定义 emits
const emit = defineEmits(["update:visible", "confirm"]);

// 方法
const closePopup = () => {
  emit("update:visible", false);
};

// 确认退出
const confirmExit = () => {
  emit("confirm");
  emit("update:visible", false);
};
</script>
